import { ItemResponsibleEnum, SalesPersonEnum } from "@project-management-system/shared-models";

export class SamplecoLineReq {
    
    buyerPo: string; 
    buyerCode: string;  
    buyerAddress: string;  
    deliveryDate: string; 
    itemNo: string;
    salesPerson: SalesPersonEnum; 
    itemResponsible: ItemResponsibleEnum;
    buyerPoDate: string;
    shipmentType: string;
    agent: string;
    orderQty: string;
    id?: number; 

    constructor(
       
        buyerPo: string,
        buyerCode: string,
        buyerAddress: string,
        deliveryDate: string,
        itemNo: string,
        salesPerson: SalesPersonEnum,
        itemResponsible: ItemResponsibleEnum,
        buyerPoDate: string,
        shipmentType: string,
        agent: string,
        orderQty: string,
        id?: number,
    ) {
        this.buyerPo = buyerPo;
        this.buyerCode = buyerCode;
        this.buyerAddress = buyerAddress;
        this.deliveryDate = deliveryDate;
        this.itemNo = itemNo;
        this.salesPerson = salesPerson;
        this.itemResponsible = itemResponsible;
        this.buyerPoDate = buyerPoDate;
        this.shipmentType = shipmentType;
        this.agent = agent;
        this.orderQty = orderQty;
        this.id = id;

    }
}




export class SamplecoLineFilterReq {
    
    buyerPo?: string; 
    buyerCode?: string; 
    itemNo?:string;
    deliveryDateStart?:any
    deliveryDateEnd?:any
    buyerStyle?:string
    status?:any;

    constructor(
       
        buyerPo?: string,
        buyerCode?: string,
        itemNo?:string,
        deliveryDateStart?:any,
        deliveryDateEnd?:any,
        buyerStyle?:string,
        status?:any,
       
    ) {
        this.buyerPo = buyerPo;
        this.buyerCode = buyerCode;
        this.itemNo =  itemNo
        this.deliveryDateStart = deliveryDateStart
        this.deliveryDateEnd = deliveryDateEnd
        this.buyerStyle = buyerStyle
        this.status = status
        

    }
}

